export enum SignOffContactsEnum {
    MODULE_ACCESS = 'View',
}
